import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useEffect, useMemo, useState } from 'react'
import Select from 'react-select'
import { appGetAllSanstha } from '../../store/sanstha'
import { appAllGetHubs } from '../../store/hubs'
import { EditorState, convertToRaw } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import { ContentState } from 'draft-js'
import htmlToDraft from 'html-to-draftjs'
import draftToHtml from 'draftjs-to-html'
import { appCreateAnnouncement } from '../../store/announcement'
import { toCamelCase } from '../../utils/Function'

function NewAnnouncement() {
	const { id } = useParams()
	const dispatch = useDispatch()
	const navigate = useNavigate()

	const { isloder } = useSelector(state => state.annoucementReducer)
	const { hub } = useSelector(state => state.hubReducer)
	const { sanstha } = useSelector(state => state.sansthaReducer)

	const handleHubChange = option => {
		formik.setFieldValue('hub', option?.value)
		dispatch(appGetAllSanstha({ page: 1, limit: 1000, hub: option?.value }))
	}

	useEffect(() => {
		dispatch(appGetAllSanstha({ page: 1, limit: 1000 }))
		dispatch(appAllGetHubs({ page: 1, limit: 1000 }))
	}, [dispatch])

	const formik = useFormik({
		initialValues: {
			title: '',
			body: '',
			hub: '',
			sanstha: '',
			admin: false,
		},
		enableReinitialize: true,
		validationSchema: Yup.object({
			body: Yup.string()
				.transform(value => {
					if (!value) return ''
					return value
						.replace(/<[^>]+>/g, '')
						.replace(/&nbsp;/gi, '')
						.trim()
				})
				.test('is-not-empty', 'Body is required', value => value && value.length > 0)
				.required('Body is required'),
			title: Yup.string().required('Title is required'),
			// hub: Yup.string().required("Community is required"),
			//  sanstha: Yup.string().required("Sanstha is required"),
		}),
		onSubmit: values => {
			//    console.log(values);
			const temp_obj = {
				title: values.title,
				body: values?.body,
				sanstha: values?.sanstha,
				hub: values?.hub,
				admin: values.admin,
				navigate: navigate,
			}
			//   console.log("temp_obj", temp_obj);
			const filtered_obj = Object.fromEntries(
				Object.entries(temp_obj).filter(
					([key, value]) =>
						value !== '' && value !== null && value !== undefined && key !== 'navigate',
				),
			)
			//   console.log(filtered_obj);
			if (id) {
			} else {
				dispatch(appCreateAnnouncement(filtered_obj)).then(() => {
					formik.resetForm()
				})
			}
		},
	})

	return (
		<>
			{isloder && <div className="loading">Loading...</div>}
			<div className="">
				<div className="card card-default">
					<div className="card-body">
						<form onSubmit={formik.handleSubmit}>
							<div className="row mb-3">
								<div className="col-md-6">
									<label>Community</label>
									<Select
										name="_id"
										options={
											Array.isArray(hub?.data)
												? hub?.data.map(place => ({
														value: place?._id,
														label: toCamelCase(place?.name),
												  }))
												: []
										}
										onChange={handleHubChange}
										value={
											Array.isArray(hub?.data)
												? hub?.data
														.filter(option => option._id === formik?.values?.hub)
														.map(option => ({
															value: option?._id,
															label: toCamelCase(option?.name),
														}))[0]
												: null
										}
										key={formik.values.hub}
										placeholder="Select Community.."
									/>
									{/* {formik.touched.hub && formik.errors.hub ? (
                    <div style={{ color: "red" }}>{formik.errors.hub}</div>
                  ) : null} */}
								</div>
							</div>

							<div className="row mb-3">
								<div className="col-md-6">
									<label>Sanstha</label>
									<Select
										options={
											Array.isArray(sanstha)
												? sanstha.map(place => ({
														value: place._id,
														label: place.name,
												  }))
												: []
										}
										onChange={opt => formik.setFieldValue('sanstha', opt?.value)}
										value={
											Array.isArray(sanstha)
												? sanstha
														.filter(option => option._id === formik?.values?.sanstha)
														.map(option => ({
															value: option._id,
															label: option.name,
														}))[0]
												: null
										}
										key={formik.values.sanstha}
										placeholder="Select Sanstha.."
									/>
									{/* {formik.touched.sanstha && formik.errors.sanstha && (
                    <div className="text-danger">{formik.errors.sanstha}</div>
                  )} */}
								</div>
							</div>

							<div className="row">
								<div className="col-md-6">
									<div className="form-group">
										<label>Send notifictaion admins and teams</label>
										<select
											className="form-control"
											name="admin"
											value={formik.values.admin ? 'Admins & teams' : 'Users'}
											onChange={e => {
												const selected = e.target.value
												formik.setFieldValue('admin', selected === 'Admins & teams')
											}}
											onBlur={formik.handleBlur}
										>
											<option value="">Select option</option>
											<option value="Users">Users</option>
											<option value="Admins & teams"> Admins & teams</option>{' '}
										</select>
									</div>
								</div>
							</div>

							<div className="row">
								<div className="col-md-6">
									<label>
										Title <span className="text-danger">*</span>
									</label>
									<input
										type="text"
										name="title"
										className="form-control"
										value={formik.values.title}
										onChange={formik.handleChange}
										placeholder="Enter title"
									/>
									{formik.touched.title && formik.errors.title && (
										<div className="text-danger">{formik.errors.title}</div>
									)}
								</div>
								<div className="col-md-6">
									<label>
										Body <span className="text-danger">*</span>
									</label>
									<textarea
										className="form-control"
										name="body"
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										value={formik.values.body}
										rows="3"
									/>
									{formik.touched.body && formik.errors.body && (
										<div className="text-danger">{formik.errors.body}</div>
									)}
								</div>
							</div>

							<div className="text-center mt-4">
								<button type="submit" className="btn btn-success mr-2">
									<i className="fa fa-check me-1"></i>
									save
								</button>
								<button type="button" className="btn btn-secondary">
									<i className="fa fa-times me-1"></i> Cancel
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</>
	)
}
export default NewAnnouncement
